import { createRoot } from "react-dom/client";
import App from "./App";
import { initAutoTheme } from "./lib/theme";
import { registerSW } from "./lib/register-sw";
import "./index.css";

initAutoTheme();
registerSW();
createRoot(document.getElementById("root")!).render(<App />);
